// components/auth/steps/MobileStep.jsx
import React from "react";
import { Button, Input, Checkbox } from "antd";
import { FiPhone, FiShield } from "react-icons/fi";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import { mobileSchema } from "../../../validations/authValidation";
import { PRIVACY_ROUTE, TERMS_ROUTE } from "../../../routes/constant";

const MobileStep = ({ onSubmit, loading, isDarkMode }) => {
  const formik = useFormik({
    initialValues: {
      mobile: "",
      acceptedTerms: true,
    },
    validationSchema: mobileSchema,
    onSubmit: (values) => onSubmit(values.mobile),
  });

  const getError = (field) => formik.touched[field] && formik.errors[field];

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <div>
        <label
          className={`text-sm font-medium mb-1 block ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
        >
          Mobile Number
        </label>
        <Input
          size="large"
          name="mobile"
          placeholder="Enter 10-digit mobile number"
          prefix={<FiPhone className="text-gray-400" />}
          value={formik.values.mobile}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 10);
            formik.setFieldValue("mobile", value);
          }}
          onBlur={formik.handleBlur}
          maxLength={10}
          status={getError("mobile") ? "error" : ""}
          className={`w-full ${isDarkMode ? "bg-gray-800 border-gray-700 text-white" : ""}`}
        />
        {getError("mobile") && (
          <div className="mt-1 text-xs text-red-500">{getError("mobile")}</div>
        )}
      </div>

      <div className="flex items-start gap-2">
        <Checkbox
          name="acceptedTerms"
          checked={formik.values.acceptedTerms}
          onChange={(e) =>
            formik.setFieldValue("acceptedTerms", e.target.checked)
          }
          className="mt-0.5"
        />
        <div>
          <span
            className={`text-xs ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}
          >
            I agree to the{" "}
            <Link to={PRIVACY_ROUTE} className="text-green-600 hover:underline">
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link to={TERMS_ROUTE} className="text-green-600 hover:underline">
              Terms of Use
            </Link>
          </span>
        </div>
      </div>
      {getError("acceptedTerms") && (
        <div className="text-xs text-red-500">{getError("acceptedTerms")}</div>
      )}

      <div
        className={`p-3 rounded-lg flex items-start gap-2 ${isDarkMode ? "bg-gray-800" : "bg-green-50"}`}
      >
        <FiShield
          className={`mt-0.5 ${isDarkMode ? "text-green-400" : "text-green-600"}`}
          size={16}
        />
        <p
          className={`text-xs ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}
        >
          Your data is end-to-end encrypted and 100% safe
        </p>
      </div>

      <Button
        type="primary"
        size="large"
        block
        htmlType="submit"
        loading={loading}
        className="bg-green-600 hover:bg-green-700"
      >
        Send OTP
      </Button>
    </form>
  );
};

export default MobileStep;